<template>
 <div>
   <Navbar />
    <div>
        <v-row> <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
         
            <v-img src="../assets/showcase.jpeg" height="100vh"></v-img>
          </v-col>
        </v-row>
      </div>
 </div>
</template>

<script>
import Navbar from '../components/Navbar.vue';


export default {
  name: "Home",

  components: {
    Navbar
    
  },
};
</script>

<style>

</style>